import { Component, Input, OnInit } from '@angular/core';
import { IconComponent } from '../icon/icon.component';
import { CommonModule, NgClass } from '@angular/common';

@Component({
    selector: 'nuc-button',
    imports: [IconComponent, NgClass, CommonModule],
    templateUrl: './button.component.html',
    styleUrl: './button.component.scss'
})
export class ButtonComponent implements OnInit {
  @Input() name: string;
  @Input() prefixIcon: string;
  @Input() styleClass: string;
  @Input() text: string;
  @Input() disabled: boolean;
  @Input() color: string;
  @Input() callback: Function;
  @Input() iconColor: string;
  @Input() size: string;

  ngOnInit(): void {
    this.disabled = this.disabled ? true : null;
    this.color = this.color || 'primary';
  }

  btnClick() {
    if (this.callback) {
      this.callback();
    }
  }
}
